import { VuePlotly } from 'vue3-plotly'
import 'plotly.js-dist-min'

export default {
  install: (app) => {
    app.component('VuePlotly', VuePlotly)
  }
} 